module.exports = __webpack_public_path__ + "static/media/design.e1db108f.jpg";